module.exports = __webpack_public_path__ + "img/folder-btn.2f536306.svg";